import { render, staticRenderFns } from "./LogBox.vue?vue&type=template&id=38f999b2"
import script from "./LogBox.vue?vue&type=script&lang=js"
export * from "./LogBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports